import { property, state } from 'lit/decorators.js';
import { html } from 'lit';

var __defProp$9 = Object.defineProperty;
var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
var __decorateClass$4 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$4(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$9(target, key, result);
  return result;
};
const ActiveMixin = (superClass) => {
  class ActiveMixinClass extends superClass {
    constructor() {
      super(...arguments);
      this.active = false;
    }
  }
  __decorateClass$4([
    property({ type: Boolean, reflect: true })
  ], ActiveMixinClass.prototype, "active", 2);
  return ActiveMixinClass;
};

var __defProp$8 = Object.defineProperty;
var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
var __decorateClass$3 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$8(target, key, result);
  return result;
};
const LabelMixin = (labelSlotName, superClass) => {
  class LabelMixinClass extends superClass {
    constructor() {
      super(...arguments);
      this._labelSlotHasContent = false;
    }
    connectedCallback() {
      super.connectedCallback();
      if (!this.label) {
        console.warn(this.tagName + " needs a `label`", this);
      }
    }
    labelSlotChanged(e) {
      this._labelSlotHasContent = e.target.assignedNodes({ flatten: true }).length > 0;
    }
    renderLabel() {
      return html`
        ${this._labelSlotHasContent === false ? html`<span class="label">${this.label}</span>` : ""}
        <slot
          class="label"
          style=${this._labelSlotHasContent ? "" : "visibility: hidden"}
          name=${labelSlotName ? labelSlotName : ""}
          @slotchange=${this.labelSlotChanged}></slot>
      `;
    }
  }
  __decorateClass$3([
    property({ type: String })
  ], LabelMixinClass.prototype, "label", 2);
  __decorateClass$3([
    state()
  ], LabelMixinClass.prototype, "_labelSlotHasContent", 2);
  return LabelMixinClass;
};

var __defProp$7 = Object.defineProperty;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
const DefaultInit$1 = {
  composed: true,
  bubbles: true
};
let UUIEvent$1 = class UUIEvent extends Event {
  constructor(evName, eventInit = {}) {
    super(evName, __spreadValues$4(__spreadValues$4({}, DefaultInit$1), eventInit));
    this.detail = eventInit.detail || {};
  }
};

var __defProp$6 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
let UUISelectableEvent$1 = class UUISelectableEvent extends UUIEvent$1 {
  constructor(evName, eventInit = {}) {
    super(evName, __spreadValues$3(__spreadValues$3({}, { bubbles: true }), eventInit));
  }
};
UUISelectableEvent$1.SELECTED = "selected";
UUISelectableEvent$1.UNSELECTED = "unselected";

var __defProp$5 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$5(target, key, result);
  return result;
};
const SelectableMixin = (superClass) => {
  class SelectableMixinClass extends superClass {
    constructor(...args) {
      super(...args);
      this._selectable = false;
      this.unselectable = true;
      this.selected = false;
      this.selectableTarget = this;
      this.addEventListener("click", this._handleClick);
      this.addEventListener("keydown", this.handleSelectKeydown);
    }
    get selectable() {
      return this._selectable;
    }
    set selectable(newVal) {
      const oldVal = this._selectable;
      this._selectable = newVal;
      this.setAttribute("tabindex", `${newVal ? "0" : "-1"}`);
      this.requestUpdate("selected", oldVal);
    }
    handleSelectKeydown(e) {
      if (e.composedPath().indexOf(this.selectableTarget) !== -1) {
        if (e.key !== " " && e.key !== "Enter")
          return;
        e.preventDefault();
        this._toggleSelect();
      }
    }
    _select() {
      if (!this.selectable)
        return;
      this.selected = true;
      this.dispatchEvent(new UUISelectableEvent$1(UUISelectableEvent$1.SELECTED));
    }
    _unselect() {
      if (!this.unselectable)
        return;
      this.selected = false;
      this.dispatchEvent(new UUISelectableEvent$1(UUISelectableEvent$1.UNSELECTED));
    }
    _handleClick(e) {
      if (e.composedPath().indexOf(this.selectableTarget) !== -1) {
        this._toggleSelect();
      }
    }
    _toggleSelect() {
      if (this.unselectable === false) {
        this._select();
      } else {
        this.selected ? this._unselect() : this._select();
      }
    }
  }
  __decorateClass$2([
    property({ type: Boolean, reflect: true })
  ], SelectableMixinClass.prototype, "selectable", 1);
  __decorateClass$2([
    property({ type: Boolean, reflect: true })
  ], SelectableMixinClass.prototype, "selected", 2);
  return SelectableMixinClass;
};

var __defProp$4 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$4(target, key, result);
  return result;
};
const SelectOnlyMixin = (superClass) => {
  class SelectOnlyMixinClass extends superClass {
    constructor() {
      super(...arguments);
      this._selectOnly = false;
    }
    get selectOnly() {
      return this._selectOnly;
    }
    set selectOnly(newVal) {
      const oldVal = this._selectOnly;
      this._selectOnly = newVal;
      this.requestUpdate("selectOnly", oldVal);
    }
  }
  __decorateClass$1([
    property({ type: Boolean, reflect: true, attribute: "select-only" })
  ], SelectOnlyMixinClass.prototype, "selectOnly", 1);
  return SelectOnlyMixinClass;
};

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
const DefaultInit = {
  composed: true,
  bubbles: true
};
class UUIEvent extends Event {
  constructor(evName, eventInit = {}) {
    super(evName, __spreadValues$2(__spreadValues$2({}, DefaultInit), eventInit));
    this.detail = eventInit.detail || {};
  }
}
var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
class UUIFormControlEvent extends UUIEvent {
  constructor(evName, eventInit = {}) {
    super(evName, __spreadValues$1(__spreadValues$1({}, { bubbles: true }), eventInit));
  }
}
UUIFormControlEvent.VALID = "valid";
UUIFormControlEvent.INVALID = "invalid";
var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class UUISelectableEvent extends UUIEvent {
  constructor(evName, eventInit = {}) {
    super(evName, __spreadValues(__spreadValues({}, { bubbles: true }), eventInit));
  }
}
UUISelectableEvent.SELECTED = "selected";
UUISelectableEvent.UNSELECTED = "unselected";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const FormControlMixin = (superClass) => {
  class FormControlMixinClass extends superClass {
    constructor(...args) {
      super(...args);
      this.name = "";
      this._validityState = {};
      this.pristine = true;
      this.required = false;
      this.requiredMessage = "This field is required";
      this.error = false;
      this.errorMessage = "This field is invalid";
      this._value = "";
      this._form = null;
      this._validators = [];
      this._formCtrlElements = [];
      this._onFormSubmit = () => {
        this.pristine = false;
      };
      this._internals = this.attachInternals();
      this.addValidator(
        "valueMissing",
        () => this.requiredMessage,
        () => this.hasAttribute("required") && this.hasValue() === false
      );
      this.addValidator(
        "customError",
        () => this.errorMessage,
        () => this.error
      );
      this.addEventListener("blur", () => {
        this.pristine = false;
      });
    }
    get value() {
      return this._value;
    }
    set value(newValue) {
      const oldValue = this._value;
      this._value = newValue;
      if ("ElementInternals" in window && "setFormValue" in window.ElementInternals.prototype) {
        this._internals.setFormValue(this._value);
      }
      this.requestUpdate("value", oldValue);
    }
    hasValue() {
      return this.value !== "";
    }
    disconnectedCallback() {
      super.disconnectedCallback();
      this._removeFormListeners();
    }
    _removeFormListeners() {
      if (this._form) {
        this._form.removeEventListener("submit", this._onFormSubmit);
      }
    }
    addValidator(flagKey, getMessageMethod, checkMethod) {
      const obj = {
        flagKey,
        getMessageMethod,
        checkMethod
      };
      this._validators.push(obj);
      return obj;
    }
    removeValidator(validator) {
      const index = this._validators.indexOf(validator);
      if (index !== -1) {
        this._validators.splice(index, 1);
      }
    }
    addFormControlElement(element) {
      this._formCtrlElements.push(element);
    }
    setCustomValidity(message) {
      if (this._customValidityObject) {
        this.removeValidator(this._customValidityObject);
      }
      if (message != null && message !== "") {
        this._customValidityObject = this.addValidator(
          "customError",
          () => message,
          () => true
        );
      }
      this._runValidators();
    }
    _runValidators() {
      this._validityState = {};
      this._formCtrlElements.forEach((formCtrlEl) => {
        for (const key in formCtrlEl.validity) {
          if (key !== "valid" && formCtrlEl.validity[key]) {
            this._validityState[key] = true;
            this._internals.setValidity(
              this._validityState,
              formCtrlEl.validationMessage,
              formCtrlEl
            );
          }
        }
      });
      this._validators.forEach((validator) => {
        if (validator.checkMethod()) {
          this._validityState[validator.flagKey] = true;
          this._internals.setValidity(
            this._validityState,
            validator.getMessageMethod(),
            this.getFormElement()
          );
        }
      });
      const hasError = Object.values(this._validityState).includes(true);
      this._validityState.valid = !hasError;
      if (hasError) {
        this.dispatchEvent(
          new UUIFormControlEvent(UUIFormControlEvent.INVALID)
        );
      } else {
        this._internals.setValidity({});
        this.dispatchEvent(new UUIFormControlEvent(UUIFormControlEvent.VALID));
      }
    }
    updated(changedProperties) {
      super.updated(changedProperties);
      this._runValidators();
    }
    submit() {
      var _a;
      (_a = this._form) == null ? void 0 : _a.requestSubmit();
    }
    formAssociatedCallback() {
      this._removeFormListeners();
      this._form = this._internals.form;
      if (this._form) {
        if (this._form.hasAttribute("submit-invalid")) {
          this.pristine = false;
        }
        this._form.addEventListener("submit", this._onFormSubmit);
      }
    }
    formResetCallback() {
      this.pristine = true;
      this.value = this.getAttribute("value") || "";
    }
    checkValidity() {
      var _a;
      for (const key in this._formCtrlElements) {
        if (this._formCtrlElements[key].checkValidity() === false) {
          return false;
        }
      }
      return (_a = this._internals) == null ? void 0 : _a.checkValidity();
    }
    get validity() {
      return this._validityState;
    }
    get validationMessage() {
      var _a;
      return (_a = this._internals) == null ? void 0 : _a.validationMessage;
    }
  }
  FormControlMixinClass.formAssociated = true;
  __decorateClass([
    property({ type: String })
  ], FormControlMixinClass.prototype, "name", 2);
  __decorateClass([
    property()
  ], FormControlMixinClass.prototype, "value", 1);
  __decorateClass([
    property({ type: Boolean, reflect: true })
  ], FormControlMixinClass.prototype, "pristine", 2);
  __decorateClass([
    property({ type: Boolean, reflect: true })
  ], FormControlMixinClass.prototype, "required", 2);
  __decorateClass([
    property({ type: String, attribute: "required-message" })
  ], FormControlMixinClass.prototype, "requiredMessage", 2);
  __decorateClass([
    property({ type: Boolean, reflect: true })
  ], FormControlMixinClass.prototype, "error", 2);
  __decorateClass([
    property({ type: String, attribute: "error-message" })
  ], FormControlMixinClass.prototype, "errorMessage", 2);
  return FormControlMixinClass;
};

export { ActiveMixin, FormControlMixin, LabelMixin, SelectOnlyMixin, SelectableMixin };
